'use client';

import { useState, useEffect, useCallback } from 'react';

const DEFAULT_POLL_INTERVAL = 3000; // 3 seconds
const DEFAULT_POLL_TIMEOUT = 120000; // 2 minutes

export default function WelcomeClient({ hasCookie, isLoggedIn, pollInterval, pollTimeout, }: { hasCookie: boolean, isLoggedIn: boolean, pollInterval?: number | null, pollTimeout?: number | null }) {
  const interval = pollInterval || DEFAULT_POLL_INTERVAL;
  const timeout = pollTimeout || DEFAULT_POLL_TIMEOUT;

  const [status, setStatus,] = useState<`polling` | `success` | `timeout` | `error` | `login`>(
    !isLoggedIn ? `login` : hasCookie ? `polling` : `success`
  );

  useEffect(() => {
    document.body.classList.add(`welcome-state-${status}`);
    return () => {
      document.body.classList.remove(`welcome-state-${status}`);
    };
  }, [status,]);

  const poll = useCallback(async () => {
    try {
      const res = await fetch(`/api/welcome`);
      const data = await res.json();

      if (data.ready) {
        setStatus(`success`);
      }
    } catch {
      setStatus(`error`);
    }
  }, []);

  useEffect(() => {
    if (status !== `polling`) return;

    const intervalId = setInterval(poll, interval);
    const timeoutId = setTimeout(() => {
      clearInterval(intervalId);
      setStatus(`timeout`);
    }, timeout);

    poll();

    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, [status, poll, interval, timeout,]);

  return <></>;
}
